import { render, staticRenderFns } from "./SyncConfigPopup.vue?vue&type=template&id=1fc4bc98&scoped=true&"
import script from "./SyncConfigPopup.vue?vue&type=script&lang=js&"
export * from "./SyncConfigPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4bc98",
  null
  
)

export default component.exports